// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { forEach, groupBy } from 'lodash';
import cx from 'classnames';

import Checkbox from 'components/Checkbox.jsx';
import { DisabledTooltipLayer } from './SelectFromList.jsx';
import EventTracking from 'lib/EventTracking';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import MediaObject from 'components/MediaObject.jsx';
import TargetFilterMenu from 'chat/components/TargetFilterMenu.jsx';
import Text from 'components/Text.jsx';
import { selectRecipient } from 'reducers/roleBasedMessagingSearch';

import type { GroupRecipient, MessageFilterType } from 'reducers/roleBasedMessagingSearch';

type Props = {
  recipient: GroupRecipient,
  recipientIsSelected: boolean,
  disabledCopy: ?string,

  // Redux dispatchers
  onSelectRecipient: (recipient: GroupRecipient, filter: ?MessageFilterType) => *,
};

type State = {
  menuIsOpen: boolean,
};

class GroupRecipientItem extends React.Component<Props, State> {
  logSelectionEvent = () => {
    if (this.props.recipientIsSelected) {
      EventTracking.trackKey('announcements.share_to.group.unselect.click');
      return;
    }
    EventTracking.trackKey('announcements.share_to.group.select.click');
  };

  handleTopLevelSelection = () => {
    this.props.onSelectRecipient(this.props.recipient, null);
  };

  render() {
    const { recipient, disabledCopy, recipientIsSelected } = this.props;
    const { group, id } = recipient;
    const filterArray = [];
    const groupedFilters = groupBy(recipient.filters, 'type');
    forEach(groupedFilters, (values, type) => {
      filterArray.push({ type, values: values.map(value => value.value) });
    });
    const component = (
      <li
        className={cx('RecipientItem', {
          'RecipientItem--disabled': !!disabledCopy,
        })}
        key={id}
        onClick={() => {
          this.handleTopLevelSelection();
          this.logSelectionEvent();
        }}
        data-test-selector={`split-composer-group-${group.id}`}>
        <MediaObject figure="right" center>
          <MediaObject gutter="small" center>
            <GroupAvatar group={group} size="small" />
            <div>
              <Text size="small" element="div" truncate>
                {group.className}
              </Text>
              {filterArray.length
                ? filterArray.map(filter => (
                    <TargetFilterMenu
                      key={filter.type}
                      filter={filter}
                      recipient={recipient}
                      recipientIsSelected={recipientIsSelected}
                      dataTestSelector={`split-composer-group-filter-${group.id}`}
                    />
                  ))
                : null}
            </div>
          </MediaObject>
          <Checkbox
            onChange={this.handleTopLevelSelection}
            checked={this.props.recipientIsSelected}
          />
        </MediaObject>
      </li>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  // $FlowIssue
  return bindActionCreators(
    {
      onSelectRecipient: selectRecipient,
    },
    dispatch
  );
};

export { GroupRecipientItem };

export default connect(
  undefined,
  mapDispatchToProps
)(GroupRecipientItem);
